import http from '../plugins/axios'

export const getPackageShipmentList = async (params) => {
  try {
    const response = await http.get(`/api/v2/packages`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const getDetailPackageShipment = async (packageShipmentId, params) => {
  try {
    const response = await http.get(`/api/v2/packages/${packageShipmentId}`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const getTemplateBroadcastPackageShipment = async (packageShipmentId, params) => {
  try {
    const response = await http.get(`/api/v2/packages/${packageShipmentId}/template-message`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const addPackageShipment = async (payload) => {
  try {
    const response = await http.post(`/api/v2/packages`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updatePackageShipment = async (packageShipmentId, payload) => {
  try {
    const response = await http.put(`/api/v2/packages/${packageShipmentId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updatePackageShipmentDocument = async (packageShipmentId, payload) => {
  try {
    const response = await http.put(`/api/v2/packages/${packageShipmentId}/document`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}


export const deletePackageShipment = async (packageShipmentId) => {
  try {
    const response = await http.delete(`/api/v2/packages/${packageShipmentId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const addPackageShipmentStatus = async (trackingId, payload) => {
  try {
    const response = await http.post(`/api/v2/packages/${trackingId}/status`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updatePackageShipmentStatus = async (trackingId, payload) => {
  try {
    const response = await http.put(`/api/v2/packages/${trackingId}/status`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deletePackageShipmentStatus = async (trackingId, payload) => {
  const data = {
    statusable_id: payload
  }
  try {
    const response = await http.delete(`/api/v2/packages/${trackingId}/status`, { data })
    return response.data
  } catch(error) {
    throw error
  }
}